import { createApi } from '@reduxjs/toolkit/query/react';
import { type TItem } from '../../components/Selector/Selector';
import { type TCurrencyResponse } from '../types/CurrencyTypes';
import { baseQuery, getBaseQueryWithReauth } from '../baseQueryAuth';

export const CurrencyApi = createApi({
  reducerPath: 'CurrencyApi',
  tagTypes: ['Currency'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getCurrency: build.query<TItem[], void>({
      query: () => ({
        url: '/currency_dropdown_values/',
        method: 'GET',
      }),
      transformResponse: (response: TCurrencyResponse[]) => {
        return response.map((item: TCurrencyResponse) => ({
          id: item.id.toString(),
          name: item.value,
        }));
      },
    }),
    getCheckActivePayments: build.query({
      query: () => ({
        url: '/requisite/check_active_payments_type/',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetCurrencyQuery, useGetCheckActivePaymentsQuery } = CurrencyApi;
